import React from "react";
//import { Link } from 'react-router-dom';
import { Api } from "./../app-controller.js";
//import { useAuth } from "../components/content/auth.jsx";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import Swal from "sweetalert2";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";

class Users extends React.Component {
  initialState = {
    usuario: {
      email: "",
      departamento_id: "",
      id: "",
      municipio_id: "",
      niveles: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      nombre_departamento: "",
      nombre_municipio: "",
      telefono: "",
      usuario_id: "",
      niveles_usuario: [],
    },
    nivel_seleccionado: "",
    nivelUsuario: localStorage.nivel_actual,
    modalNiveles: false,
    working: true,
    options_niveles: Api.loadCatalogue("levels"),
    options_niveles_usuario: [],
    options_locations: Api.loadCatalogue("locations"),
    /*options_sexo: [
      { id: "M", description: "Masculino" },
      { id: "F", description: "Femenino" },
    ],*/
    options_sexo: Api.loadCatalogue("cat_sexo"),
    disabled: true,
    buscar_user: {},
    workingGrid: false,
    usuarios: [],
    paginas: 0,
    registros: 0,
    paginaActual: 0,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
    this.handleOpenUsuario = this.handleOpenUsuario.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleLevels = this.handleLevels.bind(this);
    this.handleActive = this.handleActive.bind(this);
    this.removeLevel = this.removeLevel.bind(this);
    this.addLevel = this.addLevel.bind(this);

    this.handleDepartamentos = this.handleDepartamentos.bind(this);
    this.handleMunicipios = this.handleMunicipios.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleInfoUsuario = this.handleInfoUsuario.bind(this);
    this.handleSaveInfoUsuario = this.handleSaveInfoUsuario.bind(this);
    this.handleSearchUsuario = this.handleSearchUsuario.bind(this);
    this.maxLengthCheck = this.maxLengthCheck.bind(this);
    this.handleUserPage = this.handleUserPage.bind(this);
  }
  crearUsuario = "";
  componentDidMount() {
    // si el usuario no es nivel inspector redireccionamos a home
    if (this.state.nivelUsuario !== "2") {
      window.location.href = "/";
    }

    this.setUserPage(1);

    let buscadorUsuarios = Api.form({
      target: "#busqueda",
      name: "buscador",
      class: "panel",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 5,
            name: "nombre",
            type: "text",
            label: "Nombre",
            placeHolder: "Ingrese nombre",
          },
        },
        {
          input: {
            cols: 3,
            name: "telefono",
            type: "text",
            label: "Teléfono",
            placeHolder: "Ingrese teléfono",
          },
        },
        {
          input: {
            cols: 4,
            name: "email",
            type: "text",
            label: "Correo electrónico",
            placeHolder: "Ingrese correo electrónico",
          },
        },
        {
          select: {
            name: "departamento_id",
            label: "Departamento",
            placeHolder: "Seleccione",
            cols: 3,
          },
        },
        {
          select: {
            name: "municipio_id",
            label: "Municipio",
            placeHolder: "Seleccione",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
            },
          },
        },{
          select: {
            name: "nivel",
            label: "Nivel",
            placeHolder: "Seleccione",
            cols: 2,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
            },
          },
        },
        /*{
          button: {
            cols: 2,
            name: "reset",
            text: "Limpiar",
            icon: "fa fa-trash",
            class: "form-control btn btn-lg btn-warning ",
            click: (e) => {
              buscadorUsuarios.clear();
              gridUsuarios.go(1);
              Swal.close();
            },
          },
        },*/
        {
          button: {
            cols: 2,
            name: "buscar",
            text: "Buscar",
            icon: "fa fa-search",
            class: "form-control  btn-warning ",
            click: (me) => {
              this.setState({ buscar_user: buscadorUsuarios.data() });
              let search = this.state.buscar_user;
              
              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.setUserPage(1);
              //gridUsuarios.go(1,src);

              //gridUsuarios.go(1, buscadorUsuarios.serial());
            },
          },
        },
        {
          button: {
            cols: 2,
            name: "agregar",
            text: "Nuevo",
            icon: "fa fa-plus",
            class: "form-control btn btn-success ",
            click: (e) => {
              this.handleOpenUsuario(e);
            },
          },
        },
      ],
      onchange: (me, data, serial) => {
        //gridUsuarios.go(1, serial);
      },
      render: (me) => {
        let locations = Api.loadCatalogue("locations"); // No confundir con el plural

        let options = `<option value="">Seleccione</option>`;
        let departamentos = locations.departamentos;
        for (let departamento in departamentos) {
          options += `<option value="${departamentos[departamento].id}"> ${departamentos[departamento].name} </option>`;
        }

        departamentos = me.querySelector("#departamento_id");
        departamentos.innerHTML = options;
        departamentos.addEventListener("change", (e) => {
          let id = e.target.value;
          let municipios = locations.municipios;

          options = `<option value="">Seleccione</option>`;
          municipios
            .filter((e) => e.estado_id === id)
            .map((option) => {
              options += `<option value="${option.id}">
                                    ${option.name}
                                </option>`;
            });

          me.querySelector("#municipio_id").innerHTML = options;
        });

        let options_nivel = `<option value="">Seleccione</option>`;
        let niveles = this.state.options_niveles;
        for (let nvl in niveles) {
          options_nivel += `<option value="${niveles[nvl].id}"> ${niveles[nvl].description} </option>`;
        }
        niveles = me.querySelector("#nivel");
        niveles.innerHTML = options_nivel;

      },
    });

    //let buscadorUsuarios = Api.form(searchUser);

    /* Construimos la forma para agregar un nuevo usuario */
    let forma = {
      target: "#usuario",
      nombre: "forma",
      elementClass: "form-control",
      render: (me) => {
        /*construimos los selects */
        let niveles = [...this.state.options_niveles];
        let grupotpl = `<option value="">Seleccione</option>`;
        for (let nivel in niveles) {
          //if (niveles[nivel].description !== "Cliente") {
          grupotpl += `<option value="${niveles[nivel].id}">
                      ${niveles[nivel].description}
                  </option>`;
          //}
        }
        me.querySelector("#nivel_id").innerHTML = grupotpl;

        let sexo = [...this.state.options_sexo];
        let grupoS = `<option value="">Seleccione</option>`;
        for (let s in sexo) {
          grupoS += `<option value="${sexo[s].id}">
                      ${sexo[s].descripcion}
                  </option>`;
        }
        me.querySelector("#sexo").innerHTML = grupoS;

        let locations = Api.loadCatalogue("locations"); // No confundir con el plural

        let options = `<option value="">Seleccione</option>`;
        let departamentos = locations.departamentos;
        for (let departamento in departamentos) {
          options += `<option value="${departamentos[departamento].id}"> ${departamentos[departamento].name} </option>`;
        }

        departamentos = me.querySelector("#departamento_id");
        departamentos.innerHTML = options;

        departamentos.addEventListener("change", (e) => {
          let id = e.target.value;
          let municipios = locations.municipios;

          options = `<option value="">Seleccione</option>`;
          municipios
            .filter((e) => e.estado_id === id)
            .map((option) => {
              options += `<option value="${option.id}">
                                    ${option.name}
                                </option>`;
            });

          me.querySelector("#municipio_id").innerHTML = options;
        });
      },
      elements: [
        {
          input: {
            cols: 12,
            name: "name",
            type: "text",
            maxLength: "120",
            label: "Nombre<span class='text-danger'> *</span>",
            placeHolder: "Nombre",
            onkeyup: "this.value = this.value.toUpperCase();",
          },
        },
        {
          input: {
            cols: 6,
            name: "apellido_paterno",
            type: "text",
            maxLength: "60",
            label: "Apellido paterno <span class='text-danger'> *</span>",
            placeHolder: "Apellido paterno",
            onkeyup: "this.value = this.value.toUpperCase();",
          },
        },
        {
          input: {
            cols: 6,
            name: "apellido_materno",
            type: "text",
            maxLength: "60",
            label: "Apellido materno ",
            placeHolder: "Apellido materno",
            onkeyup: "this.value = this.value.toUpperCase();",
          },
        },
        {
          select: {
            cols: 6,
            name: "sexo",
            label: "Sexo<span class='text-danger'> *</span>",
          },
        },
        {
          input: {
            cols: 6,
            name: "telefono",
            maxLength: "8",
            label: "Teléfono<span class='text-danger'> *</span>",
            placeHolder: "Télefono",
          },
        },
        {
          select: {
            cols: 6,
            name: "departamento_id",
            label: "Departamento<span class='text-danger'> *</span>",
          },
        },
        {
          select: {
            cols: 6,
            name: "municipio_id",
            label: "Municipio<span class='text-danger'> *</span>",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
            },
          },
        },
        {
          input: {
            cols: 12,
            name: "email",
            type: "email",
            maxLength: "255",
            label: "Correo electrónico<span class='text-danger'> *</span>",
            placeHolder: "Correo electrónico",
          },
        },
        {
          input: {
            cols: 6,
            name: "password",
            type: "password",
            maxLength: "255",
            label: "Contraseña<span class='text-danger'> *</span>",
            placeHolder: "Contraseña",
          },
        },
        {
          input: {
            cols: 6,
            name: "password_confirmation",
            type: "password",
            maxLength: "255",
            label: "Confirmar contraseña<span class='text-danger'> *</span>",
            placeHolder: "Confirmar contraseña",
          },
        },
        {
          select: {
            cols: 12,
            name: "nivel_id",
            label: "Nivel<span class='text-danger'> *</span>",
          },
        },
        /*  {
                button: {
                    name: "addNivel",
                    class: "btn btn-primary",
                    cols: 1,
                    text: "",
                    icon: "fas fa-plus",
                    click: (me, data) => {
                        
                    }
                }
            }, 
        } */
      ],
    };

    this.crearUsuario = Api.form(forma);

   /*  let gridUsuarios = Api.grid({
      source: "app/getUsers",
      target: "#gridUsuarios",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      buttons: [
        {
          name: "",
          btnClass: "btn btn-primary",
          iconClass: "fas fa-edit",
          btnClick: (data) => {
            this.handleLevels(data);
          },
          render: (me, data) => {
            me.title = "Editar Usuario";
          },
        },
        {
          name: "",
          btnClass: "btn btn-success",
          iconClass: "fas fa-unlock",
          btnClick: (data) => {
            this.handleActive(data);
          },
          render: (me, data) => {
            me.title = "Deshabilitar Usuario";

            if (data.status === "0") {
              me.remove();
            }
          },
        },
        {
          name: "",
          btnClass: "btn btn-warning",
          iconClass: "fas fa-lock",
          btnClick: (data) => {
            this.handleActive(data);
          },
          render: (me, data) => {
            if (data.status === "1") {
              me.remove();
            }
          },
        },
      ],
      progressText: "Cargando Usuarios",
      rows: {
        nombre: {
          label: "Nombre Completo",
        },
        telefono: {
          label: "Teléfono",
        },
        email: {
          label: "Correo Electrónico",
        },
        nombre_departamento: {
          label: "Departamento",
        },
        nombre_municipio: {
          label: "Municipio",
        },
        niveles: {
          label: "Niveles",
          render: (me) => {
            Api.fetch("app/getGrupos?id=" + me.data.usuario_id).then((data) => {
              if (data) {
                let niveles = "";
                for (let i in data) {
                  niveles += data[i].description + ", ";
                }

                me.innerHTML = niveles.slice(0, -2);
              }
            });
          },
        },
      },
    }); */

    //Termina did mount
  }

  setUserPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscar_user;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getUsers?page=" + page + src).then((r) => {
      this.setState({
        usuarios: r.data,
        paginas: r.last_page,
        registros: r.total,
        paginaActual: r.current_page,
        workingGrid: false,
      });
    });
  }

  handleUserPage(e) {
    this.setUserPage(e.target.value);
  }

  handleOpenUsuario(e) {
    this.crearUsuario.clear();
    Swal.fire({
      title: "Agregar usuario",
      html: this.crearUsuario,
      showCancelButton: true,
      confirmButtonText: "Agregar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      preConfirm: () => {
        let dataForm = this.crearUsuario.data();
        let validEmail = new RegExp(/^\S+@\S+\.\S+$/).test(dataForm.email); // verificamos que el correo sea valido

        let pass = 1;

        if (dataForm.nivel_id === "" || !dataForm.nivel_id) {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.password !== dataForm.password_confirmation) {
          Swal.showValidationMessage(
            "Las contraseñas no concuerdan, favor de ingresarlas de nuevo"
          );
          pass = 0;
        }

        if (
          dataForm.password_confirmation === "" ||
          !dataForm.password_confirmation
        ) {
          Swal.showValidationMessage("Ingrese la confirmación de contraseña");
          pass = 0;
        }

        if (dataForm.password === "" || !dataForm.password) {
          Swal.showValidationMessage("Ingrese contraseña");
          pass = 0;
        }

        if (dataForm.email === "" || !dataForm.email || !validEmail) {
          Swal.showValidationMessage("Ingrese correo electrónico valido");
          pass = 0;
        }

        if (dataForm.municipio_id === "" || !dataForm.municipio_id) {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.departamento_id === "" || !dataForm.departamento_id) {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.telefono === "" || !dataForm.telefono) {
          Swal.showValidationMessage("Ingrese teléfono");
          pass = 0;
        }

        if (dataForm.sexo === "" || !dataForm.sexo) {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        /* if (dataForm.apellido_materno === "" || !dataForm.apellido_materno) {
          Swal.showValidationMessage("Ingrese apellido materno");
          pass = 0;
        } */

        if (dataForm.apellido_paterno === "" || !dataForm.apellido_paterno) {
          Swal.showValidationMessage("Ingrese apellido paterno");
          pass = 0;
        }

        if (dataForm.name === "" || !dataForm.name) {
          Swal.showValidationMessage("Ingrese nombre");
          pass = 0;
        }

        if (pass) {
          dataForm.name = dataForm.name.toUpperCase();
          dataForm.apellido_paterno = dataForm.apellido_paterno.toUpperCase();

          if (dataForm.apellido_materno !== undefined) {
            dataForm.apellido_materno = dataForm.apellido_materno.toUpperCase();
          }

          return Api.fetch("app/createUser", dataForm, "POST")
            .then((data) => this.handleRegister(data))
            .catch((error) => {
              error.json().then((message) => {
                this.setState({ procesando: false });
                Swal.fire({
                  title: "Ocurrió un error al procesar el usuario",
                  icon: "error",
                  text: "Revise la información e intente de nuevo su última acción", //message,
                });
              }); //catching errors to show notification
            });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  }

  handleRegister(Response) {
    if (Response.errors) {
      let tplErrors = [];
      let errorMessage = "";
      for (let error in Response.errors) {
        errorMessage = Response.errors[error].toString();

        let errox = errorMessage.split(",");

        for (let erro in errox) {
          errorMessage = errox[erro].toString();
          errorMessage = errorMessage.replace("password", "contraseña");
          errorMessage = errorMessage.replace("email", "correo electrónico");
          errorMessage = errorMessage.replace("telefono", "teléfono");
          errorMessage = errorMessage.replace("_id", "");
          tplErrors.push(errorMessage);
        }
      }

      Swal.showValidationMessage(errorMessage);

      return false;
    }

    if (Response.user) {
      if (Response.message.includes("modificado")) {
        Swal.fire({
          title: "Usuario actualizado",
          icon: "success",
          text: "La información del usuario ha sido actualizada exitosamente.",
        }).then(() => {
          this.crearUsuario.clear();
          window.location = "/usuarios";
        });
      } else {
        Swal.fire({
          title: Response.message,
          icon: "success",
          text: "Se ha enviado un correo de confirmación al usuario",
          timer: 3000,
        }).then(()=>{
          this.crearUsuario.clear();
          window.location = "/usuarios";
        });
      }
      //this.gridUsuarios.source='app/getUsers';
      //Api.grid(this.gridUsuarios);
    } else {
      Swal.fire({
        title: "Favor de revisar la información",
        icon: "warning",
        text: Response.message,
      }).then(() => {
        this.setState({ disabled: false });
      });
    }
  }

  /* ADMINISTRACION DE NIVELES DE USUARIOS EXISTENTES */
  handleLevels(e,data) {
    e.stopPropagation();
    e.preventDefault();

    let usuario = data;

    let options_niveles = [...this.state.options_niveles];

    Api.fetch("app/getGrupos?id=" + data.usuario_id).then((data) => {
      if (data) {
        usuario["niveles_usuario"] = data;

        let niveles = [];
        let options_niveles_usuario = [];

        for (let i in data) {
          niveles.push(data[i]);
        }
        //Eliminamos de la lista de niveles que puede escojer el usuario si ya tiene dicho nivel
        for (let i in options_niveles) {
          let id = options_niveles[i].id.toString();
          let level = niveles.find((d) => d.id === id);
          if (!level) {
            options_niveles_usuario.push(options_niveles[i]);
          }
        }

        this.setState({
          usuario: usuario,
          options_niveles_usuario: options_niveles_usuario, //actualizamos la lista de niveles disponibles
          modalNiveles: true,
          working: false,
        });
      }
    });
  }

  addLevel(e) {
    let options_niveles = [...this.state.options_niveles];

    let levels = this.state.usuario.niveles_usuario.find(
      (d) => d.id === this.state.nivel_seleccionado
    );

    if (levels !== undefined && this.state.nivel_seleccionado !== "0") {
      Swal.fire({
        title: "El usuario ya cuenta con el nivel seleccionado",
        text: "",
        icon: "warning",
      });
    } else {
      let usuario_id = this.state.usuario.usuario_id;
      let usuario = { ...this.state.usuario };

      Api.fetch(
        "app/addLevel",
        { usuario_id: usuario_id, level: this.state.nivel_seleccionado },
        "POST"
      ).then((data) => {
        if (data) {
          usuario["niveles_usuario"] = data;
          let niveles = [];

          let options_niveles_usuario = [];
          for (let i in data) {
            niveles.push(data[i]);
          }

          //Eliminamos de la lista de niveles que puede escojer el usuario si ya tiene dicho nivel
          for (let i in options_niveles) {
            let id = options_niveles[i].id.toString();
            let level = niveles.find((d) => d.id.toString() === id);

            if (level === undefined) {
              options_niveles_usuario.push(options_niveles[i]);
            }
          }

          this.setState({
            usuario: usuario,
            options_niveles_usuario: options_niveles_usuario, //actualizamos la lista de niveles disponibles
          });

          this.setUserPage(this.state.paginaActual);
        }
      });
    }
  }

  removeLevel(e) {
    let options_niveles = [...this.state.options_niveles];
    let usuario_id = this.state.usuario.usuario_id;
    let usuario = { ...this.state.usuario };
    if (usuario.niveles_usuario.length === 1) {
      Swal.fire({
        title: "Favor de seleccionar mínimo un nivel",
        icon: "warning",
        text: Response.message,
      });
    } else {
      Swal.fire({
        title: "Eliminar nivel",
        text: "Esta acción eliminará el nivel seleccionado.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#4CD964",
        cancelButtonColor: "red",
        cancelButtonText: "Regresar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Api.fetch(
            "app/removeLevel",
            { usuario_id: usuario_id, level: e.target.id },
            "POST"
          ).then((data) => {
            if (data) {
              usuario["niveles_usuario"] = data;
              let niveles = [];

              let options_niveles_usuario = [];
              for (let i in data) {
                niveles.push(data[i]);
              }

              //Eliminamos de la lista de niveles que puede escojer el usuario si ya tiene dicho nivel
              for (let i in options_niveles) {
                let id = options_niveles[i].id.toString();

                let level = niveles.find((d) => d.id === id);

                if (!level) {
                  options_niveles_usuario.push(options_niveles[i]);
                }
              }

              this.setState({
                usuario: usuario,
                options_niveles_usuario: options_niveles_usuario, //actualizamos la lista de niveles disponibles
              });

              //console.log(this.state.paginaActual);
              this.setUserPage(this.state.paginaActual);
            }
          });
        }
      });
    }
  }

  handleSearchUsuario() {
    console.log("si");
  }

  handleDepartamentos(e) {
    let usuario = { ...this.state.usuario };
    if (e.target.value !== "0") {
      let nombre_departamento = this.state.options_locations.departamentos.find(
        (d) => d.id.toString() === e.target.value
      );

      usuario["nombre_departamento"] = nombre_departamento.name;
    }

    usuario["departamento_id"] = e.target.value;
    this.setState({ usuario: usuario });
  }

  handleMunicipios(e) {
    let usuario = { ...this.state.usuario };
    if (e.target.value !== "0") {
      let nombre_municipio = this.state.options_locations.municipios.find(
        (d) => d.id.toString() === e.target.value
      );
      usuario["nombre_municipio"] = nombre_municipio.name;
    }

    usuario["municipio_id"] = e.target.value;
    this.setState({ usuario: usuario });
  }

  handleEdit(e) {
    this.setState({ disabled: false });
  }

  handleInfoUsuario(e) {
    let usuario = { ...this.state.usuario };

    if (
      e.target.name === "name" ||
      e.target.name === "apellido_paterno" ||
      e.target.name === "apellido_materno"
    ) {
      usuario[e.target.name] = e.target.value.toUpperCase();
    } else {
      usuario[e.target.name] = e.target.value;
    }

    this.setState({ usuario: usuario });
  }

  handleSaveInfoUsuario(e) {
    let usuario = { ...this.state.usuario };

    Api.fetch("app/updateInfoUser", usuario, "POST")
      .then((data) => this.handleRegister(data))
      .catch((error) => {
        error.json().then((message) => {
          this.setState({ procesando: false });
          Swal.fire({
            title: "Ocurrió un error al procesar la solicitud",
            icon: "error",
            text: "Revise la información e intente de nuevo su última acción", //message,
          });
        }); //catching errors to show notification
      });

    this.setState({ disabled: true });
  }

  handleActive(e,user) {
    e.stopPropagation();
    e.preventDefault();

    Api.fetch("app/updateActiveUser", user, "POST").then((data) => {
      Swal.fire({
        title: data.message,
        icon: "success",
      }).then(() => {
        window.location = "/usuarios";
      });
    });
  }

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  render() {
    const edit = this.state.disabled;
    let editButton;
    if (edit) {
      //correccion
      editButton = (
        <button onClick={this.handleEdit} className="btn btn-warning col-md-12">
          Editar
        </button>
      );
    } else {
      editButton = (
        <button
          onClick={this.handleSaveInfoUsuario}
          className="btn btn-primary col-md-12"
        >
          Guardar
        </button>
      );
    }

    return (
      <div className="row">
        <Panel className="col-sm-12">
          <PanelBody>
            <fieldset className="col-sm-12">
              <legend>Buscar Usuarios</legend>
              <div id="busqueda"></div>

              <hr />
              {/* <div id="gridUsuarios"></div> */}
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">NOMBRE COMPLETO</th>
                      <th className="text-center">TELÉFONO</th>
                      <th className="text-center">CORREO ELECTRÓNICO</th>
                      <th className="text-center">DEPARTAMENTO</th>
                      <th className="text-center">MUNICIPIO</th>
                      <th className="text-center">NIVELES</th>
                      <th className="text-center"> </th>
                      <th className="text-center"> </th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : "show"}>
                    {this.state.usuarios.map((user) => (
                      <tr key={user.id}>
                        <td className="text-left">{user.nombre}</td>
                        <td className="text-left">{user.telefono}</td>
                        <td className="text-left">{user.email}</td>
                        <td className="text-left">{user.nombre_departamento}</td>
                        <td className="text-left">{user.nombre_municipio}</td>
                        <td className="text-left">{user.niveles}</td>
                        <td className="text-center">
                          <button
                            onClick={(e) => this.handleLevels(e,user)}
                            id={user.id}
                            className="btn btn-primary"
                            title="Editar Usuario"
                          >
                            <i
                              id={user.id}
                              className="fas fa-edit"
                            ></i>
                          </button>
                        </td>
                        <th className="text-left">
                          { user.status === "1" ?
                            <button
                              onClick={(e) => this.handleActive(e,user)}
                              id={user.id}
                              className="btn btn-success"
                              title = "Deshabilitar Usuario"
                            >
                            <i
                              id={user.id}
                              className="fas fa-unlock"
                            ></i>
                            </button>
                            :
                            <button
                              onClick={(e) => this.handleActive(e,user)}
                              id={user.id}
                              className="btn btn-warning"
                              title = "Habilitar Usuario"
                            >
                              <i
                                id={user.id}
                                className="fas fa-lock"
                              ></i>
                            </button>
                          }
                        </th>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setUserPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setUserPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setUserPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setUserPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleUserPage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </fieldset>
          </PanelBody>
        </Panel>

        <Modal size="lg" isOpen={this.state.modalNiveles}>
          <ModalHeader
            toggle={() => this.setState({ modalNiveles: false })}
          ></ModalHeader>
          <ModalBody>
            <div className={this.state.working ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>

            <div className={this.state.working ? "hide" : ""}>
              <div className="col-md-12">
                <div className="row">
                  <div className="form-group col-md-4">
                    <label>Nombre</label>
                    <input
                      type="text"
                      name="name"
                      value={this.state.usuario.name}
                      onChange={this.handleInfoUsuario}
                      className="form-control m-b-5"
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div className="form-group col-md-4">
                    <label>Apellido Paterno</label>
                    <input
                      type="text"
                      name="apellido_paterno"
                      value={this.state.usuario.apellido_paterno}
                      onChange={this.handleInfoUsuario}
                      className="form-control m-b-5"
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div className="form-group col-md-4">
                    <label>Apellido Materno</label>
                    <input
                      type="text"
                      name="apellido_materno"
                      value={this.state.usuario.apellido_materno}
                      onChange={this.handleInfoUsuario}
                      className="form-control m-b-5"
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Correo electrónico</label>
                    <input
                      type="text"
                      name="email"
                      value={this.state.usuario.email}
                      onChange={this.handleInfoUsuario}
                      className="form-control m-b-5"
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Teléfono</label>
                    <input
                      type="text"
                      name="telefono"
                      maxLength="8"
                      onInput={this.maxLengthCheck}
                      value={this.state.usuario.telefono}
                      onChange={this.handleInfoUsuario}
                      className="form-control m-b-5"
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Departamento</label>
                    <select
                      onChange={this.handleDepartamentos}
                      name="departamento_id"
                      className="form-control m-b-5"
                      value={this.state.usuario.departamento_id}
                      disabled={this.state.disabled}
                    >
                      <option value="0" className="dropdown-item">
                        Seleccione...
                      </option>
                      {this.state.options_locations.departamentos.map(
                        (option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        )
                      )}
                    </select>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Municipio</label>
                    <select
                      onChange={this.handleMunicipios}
                      name="municipio_id"
                      className="form-control m-b-5"
                      value={this.state.usuario.municipio_id}
                      disabled={this.state.disabled}
                    >
                      <option value="0" className="dropdown-item">
                        Seleccione...
                      </option>
                      {this.state.options_locations.municipios
                        .filter(
                          (e) =>
                            e.estado_id === this.state.usuario.departamento_id
                        )
                        .map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group col-md-12">{editButton}</div>

                  <div className="table-responsive">
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th className="text-center">Nivel</th>

                          <th></th>
                        </tr>
                      </thead>
                      <tbody className={this.state.working ? "hide" : "show"}>
                        {this.state.usuario.niveles_usuario.map((nivel) => (
                          <tr key={nivel.id}>
                            <td className="text-center">{nivel.description}</td>
                            <td className="text-center">
                              <div className="btn-group">
                                <button
                                  //data-solicitud_id={reg.solicitud_id}
                                  onClick={this.removeLevel}
                                  id={nivel.id}
                                  className="btn btn-danger"
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td className="text-center">
                            <select
                              name="nivel_seleccionado"
                              className="form-control col-md-12"
                              value={this.state.nivel}
                              onChange={(e) =>
                                this.setState({
                                  nivel_seleccionado: e.target.value,
                                })
                              }
                            >
                              <option value="0" className="dropdown-item">
                                Seleccione...
                              </option>
                              {this.state.options_niveles_usuario
                                //.filter((e) => e.id !== 1)
                                .map((option) => (
                                  <option
                                    className="dropdown-item"
                                    key={option.id}
                                    value={option.id}
                                  >
                                    {option.description}
                                  </option>
                                ))}
                            </select>
                          </td>
                          <td className="text-center">
                            <div className="btn-group">
                              <button
                                className="btn btn-primary m-b-5"
                                onClick={this.addLevel}
                              >
                                <i className="fas fa-plus"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="form-group col-md-12"></div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <template>
          <div id="usuario"></div>
        </template>
      </div>
    );
  }
}

export default Users;
